if (!customElements.get('native-buy-controls')) {
  customElements.define('native-buy-controls', class extends HTMLElement {
    connectedCallback() {
      this.init = () => {
        this.button = this.querySelector('[name="add"]');
        this.label = this.querySelector('.native-atc-text');
        this.input = this.querySelector('input[name="id"]');
        if (!this.button || !this.label || !this.input) return;
        this.prices = JSON.parse(this.querySelector('[data-native-variant-prices]')?.textContent || '{}');
        this.defaultLabel = this.dataset.defaultLabel || this.label.textContent.trim();
        this.scope = document.getElementById(`shopify-section-${this.dataset.section}`) || this;
        if (this.dataset.position !== 'none') {
          const quantity = this.scope.querySelector(`[id="Quantity-Form-${this.dataset.section}"]`);
          if (quantity && quantity.querySelector(`input[form="${this.input.form.getAttribute('id')}"]`)) {
            this.quantityHome = document.createComment('Original quantity position');
            quantity.before(this.quantityHome);
            this.quantity = quantity;
            this.querySelector('.native-atc-row').prepend(quantity);
          }
        }
        this.update = () => {
          if (this.button.disabled) return;
          const title = this.dataset.label || this.defaultLabel;
          const price = this.dataset.displayPrice === 'true' ? this.prices[this.input.value] : '';
          const text = price ? (this.dataset.pricePosition === 'right' ? `${title} ${this.dataset.separator} ${price}` : `${price} ${this.dataset.separator} ${title}`) : title;
          if (this.label.textContent !== text) this.label.textContent = text;
        };
        this.observer = new MutationObserver(this.update);
        this.observer.observe(this.button, {attributes:true, attributeFilter:['disabled'],childList:true,subtree:true,characterData:true});
        this.observer.observe(this.input, {attributes:true,attributeFilter:['value']});
        this.scope.addEventListener('change', this.update);
        this.update();
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.init, {once:true});
      else this.init();
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.init);
      this.observer?.disconnect();
      this.scope?.removeEventListener('change', this.update);
      if (this.quantityHome?.isConnected) this.quantityHome.replaceWith(this.quantity);
    }
  });
}
